import { BoardOrder, BoardParticipant } from 'types';

export default function getVoteValueInOrder(
  participant: BoardParticipant,
  order: BoardOrder
) {
  const orderVote = participant?.votes?.find(
    (vote: any) => vote.order === order?._id
  );

  if (orderVote) {
    return orderVote.vote;
  }
  return '';
}
